export default "__VITE_ASSET__mwXghTbW__"